

















































import Vue from "vue";
import {Prop, Watch} from "vue-property-decorator";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {ProjectWithJobHistories} from "../model/interface/project.interface";
import {MigrationService} from "../services/migration.service";
import Component from "vue-class-component";
import {ProjectService} from "../services/project.service";
import {JobHistory, JobHistoryWithLogs} from "../model/interface/job-history.interface";
import JobLogsComponent from "./job-logs.vue";
import {JobLog} from "../model/interface/job-log.interface";

@Component({
  components: {
    JobLogsComponent
  }
})
export default class ProjectMigrationComponent extends Vue {
  @Prop(Number) projectId!: number;
  @Prop(Number) activateDialog!: number;

  private loading: boolean = false;
  private showDialog: boolean = false;
  private project: ProjectWithJobHistories = null;

  private selectedJobHistory: JobHistory = null;
  private selectedJobLogs: JobLog[] = [];
  private showLogsDialog: number = 0;


  private format(date: string) {
    if(date === "0" || date === null) {
      return "";
    }
    let formatted: Date = new Date(date);
    return formatted.toLocaleString('de-DE', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
  }
  private formatRuntime(runtime: number) {
    let sec_num:number = Math.floor(runtime / 1000); // don't forget the second param
    let hours:number   = Math.floor(sec_num / 3600);
    let minutes:number = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds: number = sec_num - (hours * 3600) - (minutes * 60);

    let hoursString = hours.toString();
    let minutesString = minutes.toString();
    let secondsString = seconds.toString();

    if (hours   < 10) {hoursString   = "0"+hours.toString();}
    if (minutes < 10) {minutesString = "0"+minutes.toString();}
    if (seconds < 10) {secondsString = "0"+seconds.toString();}
    return hoursString+':'+minutesString+':'+secondsString;
  }

  async mounted() {
    this.showDialog = true;
    await this.loadProjectById(this.projectId);
  }

  private sortByDateDESC(jobHistories: JobHistory[]) {
    jobHistories.sort((a: JobHistory, b: JobHistory) => {
      let formattedA: Date = new Date(a.jobStart);
      let formattedB: Date = new Date(b.jobStart);
      if (formattedA > formattedB) {
        return -1;
      }
      if (formattedA < formattedB) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    });
    return jobHistories;
  }

  private async loadProjectById(projectId: number) {
    this.loading = true;
    //API request to get Migration Infos
    try {
      const projectWithJobHistory: ProjectWithJobHistories | false = await ProjectService.getProject(projectId);
      if(projectWithJobHistory) {
        this.project = projectWithJobHistory;
        this.project.jobHistories = this.sortByDateDESC(this.project.jobHistories);
      }
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Migration Infos fetch! ' + e);
    } finally {
      this.loading = false;
    }
  }

  @Watch("activateDialog")
  onDialogChange(activateDialog: number) {
    this.showDialog = true;
    this.loadProjectById(this.projectId);
  }

  private async triggerMigration() {
    try {
      let result = <string | false> await MigrationService.triggerMigration(this.project.id);
      if(result && result === 'OK') {
        MessageBus.$emit(AlertType[AlertType.success], `Migration triggered for project ${this.project.id} !`);
      }
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], e);
    }
  }

  private onSelectJob(job: JobHistory) {
    this.selectedJobHistory = job;
  }

  private async showLogs() {
    if(!this.selectedJobHistory)
      return;

    //API Call to Job Logs
    try {
      let result = <JobHistoryWithLogs | false> await MigrationService.getProjectWithJobLogs(this.selectedJobHistory.jobHistoryId);
      if(result) {
        this.selectedJobLogs = result.jobLogs;
        this.showLogsDialog++;
      }
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], e);
    }
  }
  get jobLogsButtonDisabled() {
    return {
      'wimpub_button_disabled': this.selectedJobHistory === null
    };
  }

  private cancel() {
    this.selectedJobHistory = null;
    this.showDialog = false;
    this.selectedJobLogs = [];
  }
}
